const HERO_ASSET_ID = 'a8366f24a5ef53379be4c4abd712beb9-1774362087759/hero-main';
const HERO_MOBILE_ASSET_ID = 'a8366f24a5ef53379be4c4abd712beb9-1774362087770/hero-main-vertical';

const CLOUDINARY_VIDEO_BASE = 'https://fiverr-res.cloudinary.com/video/upload';
const ASSET_PATH = 'v1/video-attachments/generic_asset/asset';

export const HOLLYWOOD_HERO_VIDEO_URL = `${CLOUDINARY_VIDEO_BASE}/f_auto:video,q_auto:low,w_1280/${ASSET_PATH}/${HERO_ASSET_ID}`;
export const HOLLYWOOD_HERO_VIDEO_POSTER = `${CLOUDINARY_VIDEO_BASE}/f_auto,q_auto,so_0,w_1280/${ASSET_PATH}/${HERO_ASSET_ID}`;

export const HOLLYWOOD_HERO_VIDEO_URL_MOBILE = `${CLOUDINARY_VIDEO_BASE}/f_auto:video,q_auto:low,w_600/${ASSET_PATH}/${HERO_MOBILE_ASSET_ID}`;
export const HOLLYWOOD_HERO_VIDEO_POSTER_MOBILE = `${CLOUDINARY_VIDEO_BASE}/f_auto,q_auto,so_0,w_600/${ASSET_PATH}/${HERO_MOBILE_ASSET_ID}`;

export const HERO_TITLE = 'The AI Director era has arrived';
export const HERO_SUBTITLE =
    'From vision to final frame, work with the most renowned AI Video Directors to create scroll-stopping content and campaigns that drive real impact.';
export const HERO_CTA_TEXT = 'Explore AI Video Directors';
